import { useMemo } from 'react';
import { buildHistogramFromEngineBuckets } from '../../pdf/helpers/float-histogram-builder.js';

/**
 * Float distribution histogram for Check #19.
 *
 * SURFACE-COHERE (R14): renders the engine's EMITTED canonical buckets (the
 * 7-bin + noData set) and its `distribution_summary` verbatim — the SAME
 * `buildHistogramFromEngineBuckets` the PDF assembler uses (one renderer, one
 * palette, one sentence; no display-side composition). The noData bar is
 * dropped at 0 by the helper, matching the PDF. Legacy reports whose
 * dashboard.json predates this era carry the old six buckets and no summary;
 * the helper renders those buckets (label-resolved) and the sentence is absent.
 */
export function FloatHistogram({ buckets, distributionSummary }) {
  const view = useMemo(() => {
    if (Array.isArray(buckets) && buckets.length > 0) {
      return buildHistogramFromEngineBuckets(buckets, distributionSummary);
    }
    return null;
  }, [buckets, distributionSummary]);

  if (!view) return null;

  return (
    <figure className="float-histogram" aria-label="Float distribution by bucket">
      <div
        className="float-histogram-svg"
        dangerouslySetInnerHTML={{ __html: view.svgString }}
      />
      {view.interpretation ? (
        <figcaption className="float-histogram-caption">
          {view.interpretation}
        </figcaption>
      ) : null}
    </figure>
  );
}
